import { useEffect, useState } from 'react'
import lunr, { Index } from 'lunr'

export type Category =
    | 'General'
    | 'quick service'
    | 'table service'
    | 'kds'
    | 'help'
export interface IDocument {
    id: number
    title: string
    category: Category
    lastUpdated: string
    relatedDocs: string[]
    tags: string[]
    content: string
    contentText: string
}

function useHelpDocuments() {
    const [loadingContent, setLoadingContent] = useState<boolean>(false)
    const [docs, setDocs] = useState<IDocument[]>([])
    const [docIndex, setDocIndex] = useState<Index>()

    useEffect(() => {
        const getDocIndex = () => {
            fetch('/docs-index.json')
                .then((i) => i.text())
                .then((i) => setDocIndex(lunr.Index.load(JSON.parse(i))))
        }
        const getDocs = () => {
            setLoadingContent(true)
            fetch('/docs.json')
                .then((i) => i.text())
                .then((i) => {
                    setDocs(JSON.parse(i))
                })
                .finally(() => setLoadingContent(false))
        }
        getDocIndex()
        getDocs()
    }, [])

    return {
        docs,
        docIndex,
        loadingContent,
    }
}
export default useHelpDocuments
